export function buildQueryFilters(filters) {
  return Object.keys(filters)
    .map((key) => {
      const value = filters[key].value

      if (key === 'sourceId' && Array.isArray(value)) {
        if (value.length === 1) {
          return `sourceId=${value[0]}`
        }

        return `sourceIds=${value.join(',')}`
      }

      if (Array.isArray(value)) {
        return value.map((currentValue) => `${key}=${currentValue}`).join('&')
      }

      return `${key}=${value}`
    })
    .join('&')
}